import React from 'react'

export interface StepItem {
  id: string | number
  name: string
  durationMs?: number
  status?: 'success' | 'failed' | 'skipped' | 'pending'
  itemCount?: number | null
}

interface StepperProps {
  steps: StepItem[]
  activeStepIndex: number
  onStepChange: (index: number) => void
  children?: React.ReactNode
}

export function Stepper({ steps, activeStepIndex, onStepChange, children }: StepperProps) {
  return (
    <div className="stepper-layout">
      <aside className="stepper-sidebar">
        <h3 className="stepper-sidebar-title">Pipeline Funnel</h3>
        <nav className="stepper-list" aria-label="Pipeline steps">
          {steps.map((step, index) => {
            const isActive = index === activeStepIndex
            const isCompleted = index < activeStepIndex
            
            let statusClass = 'step-pending'
            if (step.status === 'success') statusClass = 'step-success'
            else if (step.status === 'failed') statusClass = 'step-failed'
            else if (step.status === 'skipped') statusClass = 'step-skipped'
            else if (isCompleted) statusClass = 'step-completed'

            return (
              <button
                key={step.id}
                type="button"
                className={`stepper-item ${isActive ? 'active' : ''} ${statusClass}`}
                onClick={() => onStepChange(index)}
              >
                <div className="step-marker">
                  {step.status === 'success' || (isCompleted && step.status !== 'failed') ? (
                    <span className="step-checkmark">✓</span>
                  ) : (
                    <span className="step-number">{index + 1}</span>
                  )}
                </div>
                <div className="step-info">
                  <span className="step-name">{step.name}</span>
                  <div className="step-meta">
                    {step.durationMs !== undefined && (
                      <span className="step-duration">{step.durationMs.toFixed(1)}ms</span>
                    )}
                    {step.itemCount !== undefined && step.itemCount !== null && (
                      <span className="step-count">{step.itemCount} items</span>
                    )}
                  </div>
                </div>
              </button>
            )
          })}
        </nav>
      </aside>
      
      <main className="stepper-content">
        <div className="stepper-navigation-buttons">
          <button
            type="button"
            className="btn-secondary"
            disabled={activeStepIndex === 0}
            onClick={() => onStepChange(activeStepIndex - 1)}
          >
            ← Previous
          </button>
          <span className="stepper-progress-indicator">
            Step {activeStepIndex + 1} of {steps.length}
          </span>
          <button
            type="button"
            className="btn-secondary"
            disabled={activeStepIndex === steps.length - 1}
            onClick={() => onStepChange(activeStepIndex + 1)}
          >
            Next →
          </button>
        </div>
        <div className="step-pane-inner">
          {children}
        </div>
      </main>
    </div>
  )
}
